<tec-modal
    [isVisible]="isVisible"
    [title]="'OPERATIONS.DETAIL.BANK_SCORING_MODAL_TITLE' | translate"
    (closeEvent)="close()"
>
    <ng-container body>
        @if (hasMismatch()) {
            <tec-alert
                status="warning"
                [msg]="'OPERATIONS.DETAIL.BANK_SCORING_MODAL_ALERT' | translate"
                [hiddenCloseButton]="true"
            />
        }
        <tec-table
            [headers]="[
                { label: ('OPERATIONS.DETAIL.BANK_SCORING_MODAL_COL_TYPE' | translate) },
                { label: ('OPERATIONS.DETAIL.BANK_SCORING_MODAL_COL_CONNECTION' | translate) },
                { label: ('OPERATIONS.DETAIL.BANK_SCORING_MODAL_COL_DATA' | translate) },
            ]"
            [rows]="rows()"
            [config]="{ clickeable: false, borderless: true }"
        />
    </ng-container>
</tec-modal>
